import { render, staticRenderFns } from "./gasClampTrial.vue?vue&type=template&id=5c0fa902&scoped=true"
import script from "./gasClampTrial.vue?vue&type=script&lang=js"
export * from "./gasClampTrial.vue?vue&type=script&lang=js"
import style0 from "./gasClampTrial.vue?vue&type=style&index=0&id=5c0fa902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fa902",
  null
  
)

export default component.exports